import { Bar } from 'vue-chartjs/legacy';
import { Chart, registerables } from 'chart.js';
import getChartOptionsSafetyStatistic from '@/store/modules/statistics/dispatchStatistics/options';

Chart.register(...registerables);

export default {
	extends: Bar,
	props: {
		chartData: Object,
		graphA: Boolean,
		graphB: Boolean,
	},
	watch: {
		graphA(val) {
			this.toggleDatasetVisibility(0, !val);
		},
		graphB(val) {
			this.toggleDatasetVisibility(1, !val);
		},
		chartData: {
			handler(newVal) {
				if (newVal && Object.keys(newVal).length > 0) {
					this.renderWithTheme();
				}
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		renderWithTheme() {
			if (!this.chartData) return;
			const options = {
				...getChartOptionsSafetyStatistic(),
				onClick: this.handlePointClick,
			};
			this.renderChart(this.chartData, options);
		},
		toggleDatasetVisibility(index, hidden) {
			const chart = this.$data._chart;
			if (!chart) return;
			const datasetMeta = chart.getDatasetMeta(index);
			datasetMeta.hidden = hidden ? true : null;
			chart.update();
		},
		handlePointClick(event) {
			const chart = this.$data._chart;
			const points = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
			if (points.length) {
				const point = points[0];
				const datasetIndex = point.datasetIndex;
				const index = point.index;
				const value = chart.data.datasets[datasetIndex].data[index];
				const label = chart.data.labels[index];
				this.$emit('updatePoint', { label, value, datasetIndex, index });
			}
		},
		delayedThemeRender() {
			requestAnimationFrame(() => {
				this.renderWithTheme();
			});
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.renderWithTheme();
		});
		window.addEventListener('themeChanged', this.delayedThemeRender);
	},
	beforeDestroy() {
		window.removeEventListener('themeChanged', this.delayedThemeRender);
	},
};
